/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a Permission
 * @export
 * @interface ApiPermission
 */
export interface ApiPermission {
    /**
     * 
     * @type {string}
     * @memberof ApiPermission
     */
    name: string;
}

/**
 * Check if a given object implements the ApiPermission interface.
 */
export function instanceOfApiPermission(value: object): value is ApiPermission {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ApiPermissionFromJSON(json: any): ApiPermission {
    return ApiPermissionFromJSONTyped(json, false);
}

export function ApiPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPermission {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function ApiPermissionToJSON(json: any): ApiPermission {
    return ApiPermissionToJSONTyped(json, false);
}

export function ApiPermissionToJSONTyped(value?: ApiPermission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

